export default __webpack_public_path__ + "static/media/image_01.628b02a2.png";